import React from "react"
import { DD, PO } from "./TypesButtons"

const Types = ({ uuid = null, openTsModal = () => null }) => {
  if (!uuid) return null

  return (
    <>
      <PO openTsModal={openTsModal} />
      <DD />
    </>
  )
}

export default Types
